module.exports = __webpack_public_path__ + "static/media/6.2a5e4fd2.JPG";